<template>
  <v-card>
    <Loader :absolute="true" :loading="loading" />
    <v-card-title class="grey text-white">{{order.created_at | dateTime}}</v-card-title>
    <v-card-text class="mb-0 pb-0">
      <h4 class="pb-0 mb-0">
        <b>Заказ:</b>
        CS-{{order.id}}
      </h4>
    </v-card-text>
    <v-card-text class="pb-2">
      <b>Статус:</b>
      
      <span class="text-warning" v-if="order.status===1">Новый</span>
      <span class="text-primary" v-else-if="order.status===2">Выполнен</span>
      <span class="error--text" v-else-if="order.status===3">Отменен</span>

    </v-card-text>

    <v-card-text class="pb-2">
      <ProductsList :productsList="order.purchases" />
    </v-card-text>

    <v-card-text>
      <h5>
        <b>Итого:</b>
        {{order.total }} баллов
      </h5>
    </v-card-text>

    <v-card-actions class="text-xs-center">
      <v-btn v-bind:disabled="order.status==2" color="success" text @click="setStatus(2)">Завершить</v-btn>
      <v-btn color="primary" text v-bind:disabled="order.status==3" @click="setStatus(3)">Отменить</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ProductsList from "../ProductsList";
import Loader from "../../helper/Loader";

export default {
  components: { Loader, ProductsList },
  data() {
    return {
      loading: false
    };
  },
  props: ["currentOrder", "setOrders"],
  methods: {
    setStatus(status) {
      this.loading = true;
      axios
        .post("admin/orders/status", {
          status: status,
          order_id: this.currentOrder.id
        })
        .then(response => {
          this.$toast.success({
            title: "Статус заказа",
            message: "Вы успешно обновили статус заказа"
          });
          this.setOrders("dsdsds");
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i]
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    order: {
      get() {
        return this.currentOrder;
      },
      set(val) {
        // this.currentOrder = val;
      }
    }
  }
};
</script>

<style>
.text-white {
  color: #ffffff !important;
  font-weight: 500;
}
</style>
